import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MarketingLeadsPage from "../components/marketing-leads/MarketingLeadsPage";
import * as catalogActions from "../redux/actions/catalogActions";

function mapStateToProps(state) {
  return {
    catalog: state.catalogReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...catalogActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MarketingLeadsPage);
